import { t } from 'i18next';

export default function getDefaultValidationMessages() {
    return {
        required: t(['generic.error.required', 'This field is required']),
    };
}
